import './assets/main.css'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import VConsole from 'vconsole'
import { IconFont } from '@nutui/icons-vue'
import 'virtual:svg-icons-register'

import App from './App.vue'
import '@/assets/font/fonts.css'
import '@nutui/icons-vue/dist/style_iconfont.css'
import '@nutui/nutui/dist/style.css'
import { Locale } from '@nutui/nutui';
// 引入英文语言包
import enUS from '@nutui/nutui/dist/packages/locale/lang/en-US';

import {router} from '@/router/index.js'
import GlobalDirectives from './directives'
import { DynamicImg } from '@/utils/util'

import appEnhance from '@/components/nutui'
import SvgIcon from '@/components/SvgIcon'
import Searchbar from '@/components/Searchbar'
import BottomButton from '@/components/bottom-button'
import Picker from '@/components/formItem/picker'
import ListCheckbox from '@/components/list-checkbox'
import FilterCheckbox from '@/components/filter/checkbox'
import FilterRadio from '@/components/filter/radio'
import Empty from '@/components/empty'


Locale.use('en-US', enUS);
const app = createApp(App)
if (['loc', 'dev'].includes(import.meta.env.VITE_APP_ENV)) {
  new VConsole()
}

// 挂载原型
app.config.globalProperties.$router = router
app.config.globalProperties.$DynamicImg = DynamicImg
app.config.globalProperties.$goPage = (name, query) => router.push({ name, query: query })

app.component('svg-icon', SvgIcon)
app.component('Searchbar', Searchbar)
app.component('BottomButton', BottomButton)
app.component('Picker', Picker)
app.component('ListCheckbox', ListCheckbox)
app.component('FilterCheckbox', FilterCheckbox)
app.component('FilterRadio', FilterRadio)
app.component('Empty', Empty)


app.use(createPinia())
app.use(router)
app.use(IconFont)
app.use(GlobalDirectives)
appEnhance(app)
app.mount('#app')
